export const getPredefinedCommentsListQuery = () => `
    query getPredefinedComments($onlyActive: Boolean!) {
        predefinedComments(onlyActive: $onlyActive) {
            id
            commentText
            deviceTypes {
                id
                name
                order
            }
            active
        }
    }
`;

export const createPredefinedCommentMutation = () => `
    mutation createPredefinedComment($comment: CreatePredefinedCommentInput!) {
        createPredefinedComment(comment: $comment)
    }
`;

export const updatePredefinedCommentActiveStatusMutation = () => `
    mutation updatePredefinedCommentEnableStatus($ids: [UUID!]!, $enabled: Boolean!) {
        updatePredefinedCommentEnableStatus(ids: $ids, enable: $enabled)
    }
`;

export const getSinglePredefinedCommentQuery = () => `
    query getPredefinedComment($id: UUID!) {
        predefinedComment(id: $id) {
            id
            commentText
            deviceTypes {
                id
                name
                erroneous
                resultTypeIds
                locationIds
                order
            }
            active
        }
    }
`;

export const editPredefinedCommentMutation = () => `
    mutation updatePredefinedComment($id: UUID!, $comment: UpdatePredefinedCommentInput!) {
        updatePredefinedComment(id: $id, comment: $comment)
    }
`;
